// src/data/mockData.js

export const FLY_TIPPING_STATS = [
  { val: '1.26M',   label: 'Fly-tip incidents across the UK (2024/25)' },
  { val: '£19.3M',  label: 'Cost to councils for large incidents alone' },
  { val: '£600',    label: 'Max fine for householders without duty of care' },
  { val: '27 secs', label: 'A fly-tip occurs somewhere in the UK every 27 seconds' },
];

export const TRUST_POINTS = [
  {
    icon: '✅',
    title: 'Public register check',
    desc: 'Waste carriers are checked against the public register before they\'re approved. Scrap collection is free.',
  },
  {
    icon: '🛡️',
    title: 'Your duty of care',
    desc: 'UK law still requires you to take care who takes your waste. A record of the job is not a guarantee it was handled legally.',
  },
  {
    icon: '♻️',
    title: 'Eco Leaderboard',
    desc: 'Carriers earn Eco Credits for recycling. The scores are a guide, not a promise of how a job will be done.',
  },
  {
    icon: '📋',
    title: 'Waste transfer notes',
    desc: 'A completed job can generate a waste transfer note. Keep it as a record. It is not proof by itself that disposal was lawful.',
  },
  {
    icon: '🚫',
    title: 'Fly-tipping is banned',
    desc: 'A carrier caught fly-tipping can be removed and reported to the Environment Agency or Natural Resources Wales. That is not a promise it cannot happen.',
  },
  {
    icon: '⭐',
    title: 'Reviews from completed jobs',
    desc: 'Only customers who have completed a job can leave a review.',
  },
];

export const SERVICES = [
  { id: 1, slug: 'waste-collection',  name: 'Waste Collection',  icon: '🗑️', credits: 12, description: 'Household and commercial waste collected by local carriers.' },
  { id: 2, slug: 'man-and-van',       name: 'Man & Van',         icon: '🚐', credits: 8,  description: 'Fast local collections, deliveries and moves with trusted local carriers.' },
  { id: 3, slug: 'house-removals',    name: 'House Removals',    icon: '📦', credits: 10, description: 'Full or partial house removals with local carriers.' },
  { id: 4, slug: 'garden-clearance',  name: 'Garden Clearance',  icon: '🌿', credits: 18, description: 'Green waste, hedges, and full garden clearances — all recycled where possible.' },
  { id: 5, slug: 'scrap-collection',  name: 'Scrap Collection',  icon: '🔩', credits: 15, description: 'Free to the customer. Scrap metal and old appliances. A scrap collector collects it.' },
  { id: 6, slug: 'packing-services',  name: 'Packing Services',  icon: '🗃️', credits: 6,  description: 'Professional packing for moves and storage.' },
  { id: 7, slug: 'grass-cutting',     name: 'Grass Cutting',     icon: '✂️', credits: 8,  description: 'Lawn mowing, strimming and outdoor maintenance.' },
  { id: 8, slug: 'house-clearance',   name: 'House Clearance',   icon: '🏠', credits: 20, description: 'Complete house clearances with a recycling-first approach.' },
];

export const MOCK_JOBS = [
  {
    id: 1,
    serviceType: 'Garden Clearance',
    icon: '🌿',
    location: 'SA1 1AB',
    date: 'Tomorrow, 9am',
    budget: '£35–£55',
    description: 'Full garden clearance, lots of green waste and old timber.',
    status: 'Pending',
    customerId: 1,
    credits: 18,
    recycleRating: 'High',
    distance: '0.8 miles',
  },
  {
    id: 2,
    serviceType: 'Waste Collection',
    icon: '🗑️',
    location: 'SA4 2BT',
    date: 'Today, 2pm',
    budget: '£40–£60',
    description: '2 black bags, old sofa and broken TV.',
    status: 'Pending',
    customerId: 2,
    credits: 12,
    recycleRating: 'Medium',
    distance: '2.1 miles',
  },
  {
    id: 3,
    serviceType: 'House Removals',
    icon: '📦',
    location: 'CF10 2NA',
    date: 'Sat, 8am',
    budget: '£150–£220',
    description: 'Office clearance and removal to storage unit.',
    status: 'Pending',
    customerId: 3,
    credits: 8,
    recycleRating: 'Low',
    distance: '12 miles',
  },
  {
    id: 4,
    serviceType: 'Scrap Collection',
    icon: '🔩',
    location: 'SA2 7PQ',
    date: 'Tomorrow, 11am',
    budget: '£20–£40',
    description: 'Old washing machine, fridge and metal shelving.',
    status: 'Pending',
    customerId: 4,
    credits: 15,
    recycleRating: 'High',
    distance: '1.4 miles',
  },
];

// Illustrative names and scores for the public teaser. No registration numbers:
// a made-up number on the landing page would look like a real licence.
export const LEADERBOARD = [
  { rank: 1, initials: 'MK', name: "Mike's Clearance",  jobs: 312, rating: 4.9, ecoRate: 98, credits: 412, verified: true,  vehicle: 'Luton Van' },
  { rank: 2, initials: 'GC', name: 'GreenCarriers SW',  jobs: 201, rating: 4.8, ecoRate: 95, credits: 321, verified: true,  vehicle: 'Large Van' },
  { rank: 3, initials: 'EV', name: 'EcoVan Swansea',    jobs: 178, rating: 4.7, ecoRate: 91, credits: 247, verified: true,  vehicle: 'Large Van', isMe: true },
  { rank: 4, initials: 'JR', name: 'J&R Removals',      jobs: 190, rating: 4.6, ecoRate: 87, credits: 201, verified: true,  vehicle: 'Luton Van' },
  { rank: 5, initials: 'TC', name: 'TerraClean',        jobs: 77,  rating: 4.4, ecoRate: 75, credits: 144, verified: true,  vehicle: 'Pickup' },
  { rank: 6, initials: 'WW', name: 'WasteWise Ltd',     jobs: 55,  rating: 4.2, ecoRate: 70, credits: 110, verified: true,  vehicle: 'Large Van' },
  { rank: 7, initials: 'RS', name: 'RapidSkip',         jobs: 44,  rating: 4.0, ecoRate: 62, credits: 88,  verified: false, vehicle: 'Skip Lorry' },
];

export const MOCK_BIDS = [
  { id: 1, jobId: 1, providerId: 3, providerName: "Mike's Clearance", initials: 'MK', price: 42, eta: '45 min', rating: 4.9, jobs: 312, ecoRate: 98, rank: 1, verified: true,  status: 'Offered' },
  { id: 2, jobId: 1, providerId: 4, providerName: 'J&R Removals',     initials: 'JR', price: 48, eta: '1 hr',   rating: 4.6, jobs: 190, ecoRate: 87, rank: 4, verified: true,  status: 'Offered' },
  { id: 3, jobId: 1, providerId: 5, providerName: 'TerraClean',       initials: 'TC', price: 55, eta: '2 hr',   rating: 4.4, jobs: 77,  ecoRate: 75, rank: 5, verified: true,  status: 'Offered' },
];

export const MOCK_USERS = {
  customer: {
    id: 1,
    name: 'Alex Davies',
    email: 'customer@example.com',
    type: 'customer',
    location: 'Swansea, SA1',
  },
  provider: {
    id: 3,
    name: 'EcoVan Swansea',
    email: 'provider@example.com',
    type: 'provider',
    credits: 247,
    rating: 4.7,
    rank: 3,
    jobs: 178,
    ecoRate: 91,
    verified: true,
    vehicle: 'Large Van',
  },
};
